import { util } from './util'

// Navigation Toggles

class Navigation {
  constructor() {
    this.headerDropdown();
    this.navScroll();
    this.holidayGuide();
    // this.newletterPopup();

    const logos = document.querySelectorAll('.logo')

    if (logos.length > 0) {
      this.logoToggles(logos);
    }
  }

  headerDropdown() {
    this.navToggles = [].slice.call(
      document.querySelectorAll('.header__list__action')
    );

    this.sectionToggles = [].slice.call(
      document.querySelectorAll('.intro')
    );

    this.mobileNavToggles = [].slice.call(
      document.querySelectorAll('.header__nav-toggle')
    );

    this.dropdowns = [].slice.call(
      document.querySelectorAll('.header__list__dropdown-menu')
    );

    const holidayBar = document.querySelector('.holiday-bar')
    var windowWidth = window.innerWidth;

    function resizeListener() {
      windowWidth = window.innerWidth;
    }

    window.addEventListener("resize", resizeListener);

    this.navToggles.forEach(toggle => {
      ['click', 'keypress', 'mouseenter'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            if (windowWidth < 1024 && toggle.classList.contains('header__list__toggle')) {
              e.preventDefault()
            }
            toggle.classList.toggle('open');
            holidayBar.classList.toggle('hidden')
          } else if (e.type === 'mouseenter' && windowWidth > 1024) {
            this.navToggles.forEach(toggles => {
              toggles.classList.remove('open');
            });

            toggle.classList.add('open');
            holidayBar.classList.add('hidden')
          }
        });
      });
    });

    this.sectionToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            toggle.parentElement.parentElement.previousElementSibling.classList.remove('open');
          }
        });
      });
    });

    this.mobileNavToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            document.querySelector('.header').classList.toggle('open')
            holidayBar.classList.toggle('hidden')

            setTimeout(() => {
              this.navToggles.forEach(list => {
                list.classList.remove('open')
              })
            }, 600);
          }
        });
      });
    });

    this.dropdowns.forEach(dropdown => {
      ['mouseleave'].forEach(event => {
        dropdown.addEventListener(event, e => {
          this.navToggles.forEach(toggle => {
            toggle.classList.remove('open');
          });

          holidayBar.classList.remove('hidden')
        });
      });
    });
  }

  // TODO: UPDATE THIS FUNCTION
  navScroll() {
    var didScroll,
      lastScrollTop = 0,
      delta = 5,
      header = document.querySelector('.header');
    // if (st >= 20) {
    //   header.classList.add('header--white');
    // }

    window.addEventListener('scroll', function() {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = window.pageYOffset;

      if (Math.abs(lastScrollTop - st) <= delta)
        return;
      if (st > lastScrollTop && st > 0) {
        header.classList.add('header--scrolling');
      } else {
        if (st + window.innerHeight < document.body.offsetHeight) {
          header.classList.remove('header--scrolling');
        }
      }
      lastScrollTop = st;
    }
  }

  newletterPopup() {
    this.newsletterToggles = [].slice.call(
      document.querySelectorAll('.newsletter-popup__toggle')
    );

    const popup = document.querySelector('.newsletter-popup')
    const hasCookie = util.getCookie('popup-closed');

    if(!hasCookie) {
      setTimeout(() => {
        popup.classList.add('active')
      }, 3000);
    }

    this.newsletterToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            popup.classList.remove('active')
            util.createCookie('popup-closed', 1)
          }
        });
      });
    });
  }

  logoToggles(items) {
    
    items.forEach(logo => {
      ['click', 'keypress'].forEach(event => {
        logo.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            [].forEach.call(items, function (el) {
              el.classList.remove('swiper-slide-active');
            });

            logo.classList.add('swiper-slide-active');
          }
        });
      });
    });
  }

  holidayGuide() {
    const holidayBar = document.querySelector('.holiday-bar')
    const toggle = document.querySelector('.holiday-bar__toggle')
    // TODO: UNCOMMENT THE BELOW TO ADD IN THE PROMO EVENT FOR GA4 TRACKING
    // const promotionName = document.querySelector('.holiday-bar__toggle span').innerHTML
    if(toggle){
      toggle.addEventListener('click', function (event) {
        // TODO: UNCOMMENT THE BELOW TO ADD IN THE PROMO EVENT FOR GA4 TRACKING
        // if (!holidayBar.classList.contains('open')) {
        //   var dataLayer = window.dataLayer || [];
        //   dataLayer.push({
        //     event: 'view_promotion',
        //     ecommerce: {
        //       items: [{
        //         promotion_id: '001',
        //         promotion_name: String(promotionName),
        //         creative_name: String(promotionName),
        //         creative_slot: 1
        //       }]
        //     }
        //   })
        // }
  
        holidayBar.classList.toggle('open')
      }, false);
    } 
  } 
}

const navInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.getElementById('navigation');
    if (wrapperEl !== null) {
      new Navigation(wrapperEl);
    }
  },
};

export default navInit;
